/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * The poses data are generated from HandPoserSystem.js
 * DO NOT MODIFY BY HAND
 */
export const JOINTS_DATA = {
	EMPTY: {
		THUMB: {
			Thumb_Metacarpal: {
				DEFAULT: [
					-0.14433203637599945,
					0.2923164963722229,
					0.4463821351528168,
					0.8333441019058228,
				],
				PRESSED: [
					-0.03698112815618515,
					0.5117819309234619,
					0.37020695209503174,
					0.7743761539459229,
				],
			},
			Thumb_A: {
				DEFAULT: [
					-0.05723189935088158,
					0.039823178201913834,
					0.04977342486381531,
					0.9963238835334778,
				],
				PRESSED: [
					-0.009943823330104351,
					0.007618506904691458,
					-0.02264157496392727,
					0.9996652007102966,
				],
			},
			Thumb_B: {
				DEFAULT: [
					0.0994374081492424,
					0.07580188661813736,
					-0.05713026598095894,
					0.9905061721801758,
				],
				PRESSED: [
					0.2309984266757965,
					0.0032935570925474167,
					-0.0971335619688034,
					0.9680877923965454,
				],
			},
			Thumb_C: {
				DEFAULT: [
					0.0750655084848404,
					0.07494308799505234,
					0.001219333615154028,
					0.994357705116272,
				],
				PRESSED: [
					0.2502250075340271,
					0.08303527534008026,
					-0.02391742169857025,
					0.964323878288269,
				],
			},
		},
		INDEX: {
			Index_Metacarpal: {
				DEFAULT: [
					0.06670059263706207,
					0.009249592199921608,
					0.11007711291313171,
					0.9916393160820007,
				],
				PRESSED: [
					0.06670059263706207,
					0.009249592199921608,
					0.11007711291313171,
					0.9916393160820007,
				],
			},
			Index_A: {
				DEFAULT: [
					0.02620767429471016,
					0.009989832527935505,
					-0.00679872278124094,
					0.9995836019515991,
				],
				PRESSED: [
					0.58280348777771,
					-0.05316126346588135,
					0.020471390336751938,
					0.8106139302253723,
				],
			},
			Index_B: {
				DEFAULT: [
					0.05106634646654129,
					0.009880313649773598,
					-0.005263219587504864,
					0.998632550239563,
				],
				PRESSED: [
					0.6814810633659363,
					-0.00978525634855032,
					0.05931200459599495,
					0.7293626666069031,
				],
			},
			Index_C: {
				DEFAULT: [
					0.052774444222450256,
					-0.011579330079257488,
					-0.016679909080266953,
					0.9984000325202942,
				],
				PRESSED: [
					0.5610995888710022,
					-0.03731174394488335,
					-0.018630478531122208,
					0.826697051525116,
				],
			},
		},
		HAND: {
			Middle_Metacarpal: {
				DEFAULT: [
					0.07801032811403275,
					-0.019254308193922043,
					0.014924905262887478,
					0.9966548681259155,
				],
				PRESSED: [
					0.04639429971575737,
					-0.019349167123436928,
					0.01715395785868168,
					0.9985885620117188,
				],
			},
			Middle_A: {
				DEFAULT: [
					0.057804349809885025,
					-0.03230945020914078,
					0.018091490492224693,
					0.9976409673690796,
				],
				PRESSED: [
					0.6201587915420532,
					-0.019503116607666016,
					0.04268936812877655,
					0.7830711007118225,
				],
			},
			Middle_B: {
				DEFAULT: [
					0.02666499838232994,
					-0.002201072173193097,
					-0.0020088800229132175,
					0.9996399879455566,
				],
				PRESSED: [
					0.6680994629859924,
					-0.04093901813030243,
					0.05521367862820625,
					0.7408904433250427,
				],
			},
			Middle_C: {
				DEFAULT: [
					0.05026458203792572,
					0.014926768839359283,
					0.005633297376334667,
					0.9986085295677185,
				],
				PRESSED: [
					0.5864063501358032,
					-0.02261831983923912,
					-0.012007561512291431,
					0.8096121549606323,
				],
			},
			Ring_Metacarpal: {
				DEFAULT: [
					0.06746342033147812,
					-0.06527361273765564,
					-0.08486948907375336,
					0.9919604063034058,
				],
				PRESSED: [
					0.06755883991718292,
					-0.06520756334066391,
					-0.08653280884027481,
					0.9918144345283508,
				],
			},
			Ring_A: {
				DEFAULT: [
					0.09256289154291153,
					-0.05345386639237404,
					0.02303459495306015,
					0.9940041303634644,
				],
				PRESSED: [
					0.6061883568763733,
					-0.0188607107847929,
					0.015117265284061432,
					0.7949537634849548,
				],
			},
			Ring_B: {
				DEFAULT: [
					0.039345502853393555,
					0.0189265888184309,
					0.02411668561398983,
					0.9987553358078003,
				],
				PRESSED: [
					0.6554290652275085,
					-0.0027499236166477203,
					-0.007775472942739725,
					0.7552117109298706,
				],
			},
			Ring_C: {
				DEFAULT: [
					0.048003990203142166,
					-0.02104446478188038,
					0.006694173905998468,
					0.9986030459403992,
				],
				PRESSED: [
					0.6682729125022888,
					-0.02772667072713375,
					-0.012233586981892586,
					0.7432986497879028,
				],
			},
			Pinky_Metacarpal: {
				DEFAULT: [
					0.0485701858997345,
					-0.12754254043102264,
					-0.16250784695148468,
					0.9772231578826904,
				],
				PRESSED: [
					0.07639972865581512,
					-0.13357843458652496,
					-0.16218170523643494,
					0.9746881723403931,
				],
			},
			Pinky_A: {
				DEFAULT: [
					0.12926524877548218,
					-0.059700626879930496,
					0.0252252034842968,
					0.9894897937774658,
				],
				PRESSED: [
					0.5991054177284241,
					0.07454387843608856,
					0.062324296683073044,
					0.7947525978088379,
				],
			},
			Pinky_B: {
				DEFAULT: [
					0.04410816729068756,
					-0.004322762135416269,
					0.008885900489985943,
					0.9989778995513916,
				],
				PRESSED: [
					0.5972936153411865,
					-0.02272387221455574,
					-0.00851327646523714,
					0.8016554713249207,
				],
			},
			Pinky_C: {
				DEFAULT: [
					0.03062133677303791,
					-0.01882816292345524,
					0.02199633978307247,
					0.9991117119789124,
				],
				PRESSED: [
					0.6393718719482422,
					-0.01946001499891281,
					0.014882107265293598,
					0.7685074210166931,
				],
			},
		},
	},
	WATERING: {
		THUMB: {
			Thumb_Metacarpal: {
				DEFAULT: [
					0.07253424823284149,
					0.459504634141922,
					0.5400552749633789,
					0.7013804912567139,
				],
			},
			Thumb_A: {
				DEFAULT: [
					-0.009943850338459015,
					0.0076185003854334354,
					-0.022641567513346672,
					0.9996652007102966,
				],
			},
			Thumb_B: {
				DEFAULT: [
					0.2309984713792801,
					0.0032935303170233965,
					-0.09713359922170639,
					0.9680877923965454,
				],
			},
			Thumb_C: {
				DEFAULT: [
					0.2502249479293823,
					0.08303523808717728,
					-0.02391740493476391,
					0.9643239378929138,
				],
			},
		},
		INDEX: {
			Index_Metacarpal: {
				DEFAULT: [
					0.08609888702630997,
					0.012109999544918537,
					0.11211978644132614,
					0.9898836016654968,
				],
			},
			Index_A: {
				DEFAULT: [
					0.42544716596603394,
					-0.08349013328552246,
					-0.00424481276422739,
					0.9011138081550598,
				],
			},
			Index_B: {
				DEFAULT: [
					0.45032843947410583,
					0.0024337726645171642,
					-0.00012344715651124716,
					0.8928598165512085,
				],
			},
			Index_C: {
				DEFAULT: [
					0.34419646859169006,
					0.011193918064236641,
					0.014724532142281532,
					0.9387154579162598,
				],
			},
		},
		HAND: {
			Middle_Metacarpal: {
				DEFAULT: [
					0.06536749750375748,
					-0.017035234719514847,
					0.012536811642348766,
					0.9976370930671692,
				],
			},
			Middle_A: {
				DEFAULT: [
					0.4968579113483429,
					-0.05865836516022682,
					0.02088882215321064,
					0.8655953407287598,
				],
			},
			Middle_B: {
				DEFAULT: [
					0.44882574677467346,
					-0.015659654513001442,
					-0.0048347534611821175,
					0.8934690356254578,
				],
			},
			Middle_C: {
				DEFAULT: [
					0.31194090843200684,
					-0.02090431936085224,
					-0.0016064312076196074,
					0.9498702883720398,
				],
			},
			Ring_Metacarpal: {
				DEFAULT: [
					0.09229780733585358,
					-0.07007919251918793,
					-0.0874103233218193,
					0.9894086718559265,
				],
			},
			Ring_A: {
				DEFAULT: [
					0.45118826627731323,
					0.01008554082363844,
					0.03657606989145279,
					0.8916219472885132,
				],
			},
			Ring_B: {
				DEFAULT: [
					0.4429307281970978,
					0.01852492056787014,
					0.01227422896772623,
					0.8962804079055786,
				],
			},
			Ring_C: {
				DEFAULT: [
					0.3354717195034027,
					-0.022317297756671906,
					0.006577719934284687,
					0.9417629241943359,
				],
			},
			Pinky_Metacarpal: {
				DEFAULT: [
					0.10808300226926804,
					-0.14262734353542328,
					-0.16226939857006073,
					0.9703835248947144,
				],
			},
			Pinky_A: {
				DEFAULT: [
					0.4134065508842468,
					0.06067345291376114,
					0.04157180339097977,
					0.9075712561607361,
				],
			},
			Pinky_B: {
				DEFAULT: [
					0.32777300477027893,
					0.009892645291984081,
					-0.007307339925318956,
					0.9446764588356018,
				],
			},
			Pinky_C: {
				DEFAULT: [
					0.26724258065223694,
					0.010670619085431099,
					0.002697192132472992,
					0.9635665416717529,
				],
			},
		},
	},
	CAMERA: {
		THUMB: {
			Thumb_Metacarpal: {
				DEFAULT: [
					-0.056601110845804214,
					0.35629376769065857,
					0.40285393595695496,
					0.8411657810211182,
				],
				PRESSED: [
					-0.056601110845804214,
					0.35629376769065857,
					0.40285393595695496,
					0.8411657810211182,
				],
			},
			Thumb_A: {
				DEFAULT: [
					0.05263695493340492,
					0.011917274445295334,
					0.03772616758942604,
					0.9978296756744385,
				],
				PRESSED: [
					0.05263695493340492,
					0.011917274445295334,
					0.03772616758942604,
					0.9978296756744385,
				],
			},
			Thumb_B: {
				DEFAULT: [
					0.07935737073421478,
					0.10761220753192902,
					-0.03377040848135948,
					0.9904451370239258,
				],
				PRESSED: [
					0.07935737073421478,
					0.10761220753192902,
					-0.03377040848135948,
					0.9904451370239258,
				],
			},
			Thumb_C: {
				DEFAULT: [
					0.1389152556657791,
					0.08480436354875565,
					-0.00022120204812381417,
					0.9866665005683899,
				],
				PRESSED: [
					0.1389152556657791,
					0.08480436354875565,
					-0.00022120204812381417,
					0.9866665005683899,
				],
			},
		},
		INDEX: {
			Index_Metacarpal: {
				DEFAULT: [
					-0.044345173984766006,
					-0.024706292897462845,
					0.13131818175315857,
					0.9900397658348083,
				],
				PRESSED: [
					-0.044345173984766006,
					-0.024706292897462845,
					0.13131818175315857,
					0.9900397658348083,
				],
			},
			Index_A: {
				DEFAULT: [
					0.08537851274013519,
					-0.00233619031496346,
					0.06890720874071121,
					0.9939602017402649,
				],
				PRESSED: [
					0.1568596363067627,
					0.0041342684999108315,
					0.08158177882432938,
					0.9842369556427002,
				],
			},
			Index_B: {
				DEFAULT: [
					0.5478368401527405,
					0.03801778331398964,
					0.058478835970163345,
					0.8336725234985352,
				],
				PRESSED: [
					0.5478367209434509,
					0.038017772138118744,
					0.058478835970163345,
					0.8336725234985352,
				],
			},
			Index_C: {
				DEFAULT: [
					0.45062142610549927,
					-0.024751679971814156,
					0.01365700177848339,
					0.8922675848007202,
				],
				PRESSED: [
					0.49392351508140564,
					-0.02050020918250084,
					0.01856628805398941,
					0.8690653443336487,
				],
			},
		},
		HAND: {
			Middle_Metacarpal: {
				DEFAULT: [
					0.0840892419219017,
					-0.1206476092338562,
					-0.02400404028594494,
					0.9888361692428589,
				],
				PRESSED: [
					0.0840892419219017,
					-0.1206476092338562,
					-0.02400404028594494,
					0.9888361692428589,
				],
			},
			Middle_A: {
				DEFAULT: [
					0.2709539830684662,
					-0.1363462656736374,
					-0.08201301842927933,
					0.9493511319160461,
				],
				PRESSED: [
					0.2709539830684662,
					-0.1363462656736374,
					-0.08201301842927933,
					0.9493511319160461,
				],
			},
			Middle_B: {
				DEFAULT: [
					0.5411325693130493,
					-0.005232057999819517,
					-0.0036103224847465754,
					0.8409132957458496,
				],
				PRESSED: [
					0.5411325693130493,
					-0.005232057999819517,
					-0.0036103224847465754,
					0.8409132957458496,
				],
			},
			Middle_C: {
				DEFAULT: [
					0.33754467964172363,
					-0.007954388856887817,
					0.006235203705728054,
					0.9412552714347839,
				],
				PRESSED: [
					0.33754467964172363,
					-0.007954388856887817,
					0.006235203705728054,
					0.9412552714347839,
				],
			},
			Ring_Metacarpal: {
				DEFAULT: [
					0.13867230713367462,
					-0.1826491802930832,
					-0.11362079530954361,
					0.9666951894760132,
				],
				PRESSED: [
					0.13867230713367462,
					-0.1826491802930832,
					-0.11362079530954361,
					0.9666951894760132,
				],
			},
			Ring_A: {
				DEFAULT: [
					0.33008211851119995,
					-0.05841827392578125,
					-0.034013450145721436,
					0.9415286779403687,
				],
				PRESSED: [
					0.33008211851119995,
					-0.05841827392578125,
					-0.034013450145721436,
					0.9415286779403687,
				],
			},
			Ring_B: {
				DEFAULT: [
					0.5024216175079346,
					-0.002771124942228198,
					-0.0005457426304928958,
					0.864618182182312,
				],
				PRESSED: [
					0.5024216175079346,
					-0.002771124942228198,
					-0.0005457426304928958,
					0.864618182182312,
				],
			},
			Ring_C: {
				DEFAULT: [
					0.34441614151000977,
					-0.017347019165754318,
					-0.001983208116143942,
					0.9386547207832336,
				],
				PRESSED: [
					0.34441614151000977,
					-0.017347019165754318,
					-0.001983208116143942,
					0.9386547207832336,
				],
			},
			Pinky_Metacarpal: {
				DEFAULT: [
					0.18851245939731598,
					-0.2453935146331787,
					-0.18395237624645233,
					0.9329558610916138,
				],
				PRESSED: [
					0.18851245939731598,
					-0.2453935146331787,
					-0.18395237624645233,
					0.9329558610916138,
				],
			},
			Pinky_A: {
				DEFAULT: [
					0.38649868965148926,
					-0.000049246737034991384,
					0.0019689223263412714,
					0.9222878813743591,
				],
				PRESSED: [
					0.38649868965148926,
					-0.000049246737034991384,
					0.0019689223263412714,
					0.9222878813743591,
				],
			},
			Pinky_B: {
				DEFAULT: [
					0.25940075516700745,
					0.004636368714272976,
					0.0104971369728446,
					0.9657015800476074,
				],
				PRESSED: [
					0.25940075516700745,
					0.004636368714272976,
					0.0104971369728446,
					0.9657015800476074,
				],
			},
			Pinky_C: {
				DEFAULT: [
					0.28356030583381653,
					-0.013162889517843723,
					-0.00010945613030344248,
					0.958864152431488,
				],
				PRESSED: [
					0.28356030583381653,
					-0.013162889517843723,
					-0.00010945613030344248,
					0.958864152431488,
				],
			},
		},
	},
	PLANTING: {
		THUMB: {
			Thumb_Metacarpal: {
				DEFAULT: [
					-0.011516770347952843,
					0.34088337421417236,
					0.5765995979309082,
					0.7424276471138,
				],
			},
			Thumb_A: {
				DEFAULT: [
					0.006082755047827959,
					0.005228644236922264,
					0.04911835864186287,
					0.9987608194351196,
				],
			},
			Thumb_B: {
				DEFAULT: [
					0.2207767218351364,
					0.19638091325759888,
					-0.0967433899641037,
					0.9504383206367493,
				],
			},
			Thumb_C: {
				DEFAULT: [
					0.3173159956932068,
					0.1451440155506134,
					0.018856028094887733,
					0.9369569420814514,
				],
			},
		},
		INDEX: {
			Index_Metacarpal: {
				DEFAULT: [
					0.06670059263706207,
					0.009249592199921608,
					0.11007711291313171,
					0.9916393160820007,
				],
			},
			Index_A: {
				DEFAULT: [
					0.15200673043727875,
					-0.0025960560888051987,
					0.00015605249791406095,
					0.9883760809898376,
				],
			},
			Index_B: {
				DEFAULT: [
					0.17657938599586487,
					-0.011713062413036823,
					0.006450689863413572,
					0.9841955900192261,
				],
			},
			Index_C: {
				DEFAULT: [
					0.08105556666851044,
					-0.01837831921875477,
					-0.013013483956456184,
					0.996455192565918,
				],
			},
		},
		HAND: {
			Middle_Metacarpal: {
				DEFAULT: [
					0.07801032811403275,
					-0.019254308193922043,
					0.014924905262887478,
					0.9966548681259155,
				],
			},
			Middle_A: {
				DEFAULT: [
					0.24535472691059113,
					-0.028579432517290115,
					0.013440382666885853,
					0.9689188003540039,
				],
			},
			Middle_B: {
				DEFAULT: [
					0.5478854179382324,
					0.007067487575113773,
					-0.005238349083811045,
					0.8365071415901184,
				],
			},
			Middle_C: {
				DEFAULT: [
					0.5429393649101257,
					0.031133947893977165,
					0.010618757456541061,
					0.8391274213790894,
				],
			},
			Ring_Metacarpal: {
				DEFAULT: [
					0.06746342033147812,
					-0.06527361273765564,
					-0.08486948907375336,
					0.9919604063034058,
				],
			},
			Ring_A: {
				DEFAULT: [
					0.2424788475036621,
					-0.03701954334974289,
					0.023634782060980797,
					0.9691619873046875,
				],
			},
			Ring_B: {
				DEFAULT: [
					0.5768598318099976,
					0.04092932492494583,
					-0.022257624194025993,
					0.815513551235199,
				],
			},
			Ring_C: {
				DEFAULT: [
					0.4882573187351227,
					0.029494356364011765,
					-0.022849515080451965,
					0.87190181016922,
				],
			},
			Pinky_Metacarpal: {
				DEFAULT: [
					0.0485701858997345,
					-0.12754254043102264,
					-0.16250784695148468,
					0.9772231578826904,
				],
			},
			Pinky_A: {
				DEFAULT: [
					0.25580599904060364,
					-0.045050833374261856,
					0.02666594460606575,
					0.9653096199035645,
				],
			},
			Pinky_B: {
				DEFAULT: [
					0.3811846375465393,
					0.046003811061382294,
					-0.033094801008701324,
					0.9227603673934937,
				],
			},
			Pinky_C: {
				DEFAULT: [
					0.48589372634887695,
					0.05044881999492645,
					-0.04656097665429115,
					0.8713175654411316,
				],
			},
		},
	},
	GRABBING: {
		THUMB: {
			Thumb_Metacarpal: {
				DEFAULT: [
					-0.14433203637599945,
					0.2923164963722229,
					0.4463821351528168,
					0.8333441019058228,
				],
				PRESSED: [
					-0.07515639066696167,
					0.456220805644989,
					0.3861384987831116,
					0.7981924414634705,
				],
			},
			Thumb_A: {
				DEFAULT: [
					-0.05723189935088158,
					0.039823178201913834,
					0.04977342486381531,
					0.9963238835334778,
				],
				PRESSED: [
					0.061437368392944336,
					0.030193651095032692,
					-0.03515617921948433,
					0.9970345497131348,
				],
			},
			Thumb_B: {
				DEFAULT: [
					0.0994374081492424,
					0.07580188661813736,
					-0.05713026598095894,
					0.9905061721801758,
				],
				PRESSED: [
					0.1883590817451477,
					0.2132681906223297,
					-0.05210699886083603,
					0.9572474360466003,
				],
			},
			Thumb_C: {
				DEFAULT: [
					0.0750655084848404,
					0.07494308799505234,
					0.001219333615154028,
					0.994357705116272,
				],
				PRESSED: [
					-0.06261736899614334,
					-0.005477048456668854,
					0.041181791573762894,
					0.9971725940704346,
				],
			},
		},
		INDEX: {
			Index_Metacarpal: {
				DEFAULT: [
					0.06670059263706207,
					0.009249592199921608,
					0.11007711291313171,
					0.9916393160820007,
				],
				PRESSED: [
					-0.01962537132203579,
					-0.020836645737290382,
					0.11573323607444763,
					0.9928678274154663,
				],
			},
			Index_A: {
				DEFAULT: [
					0.02620767429471016,
					0.009989832527935505,
					-0.00679872278124094,
					0.9995836019515991,
				],
				PRESSED: [
					0.514458954334259,
					-0.10939709097146988,
					0.07089020311832428,
					0.8475487232208252,
				],
			},
			Index_B: {
				DEFAULT: [
					0.05106634646654129,
					0.009880313649773598,
					-0.005263219587504864,
					0.998632550239563,
				],
				PRESSED: [
					0.5766386985778809,
					0.023759543895721436,
					0.0035771627444773912,
					0.8166459202766418,
				],
			},
			Index_C: {
				DEFAULT: [
					0.052774444222450256,
					-0.011579330079257488,
					-0.016679909080266953,
					0.9984000325202942,
				],
				PRESSED: [
					0.4249316453933716,
					0.0015943774487823248,
					0.004842918366193771,
					0.9052112102508545,
				],
			},
		},
		HAND: {
			Middle_Metacarpal: {
				DEFAULT: [
					0.07801032811403275,
					-0.019254308193922043,
					0.014924905262887478,
					0.9966548681259155,
				],
				PRESSED: [
					0.013599473983049393,
					0.002631407231092453,
					0.04251248389482498,
					0.9989999532699585,
				],
			},
			Middle_A: {
				DEFAULT: [
					0.057804349809885025,
					-0.03230945020914078,
					0.018091490492224693,
					0.9976409673690796,
				],
				PRESSED: [
					0.6541677713394165,
					-0.12683022022247314,
					0.0764317438006401,
					0.7417120933532715,
				],
			},
			Middle_B: {
				DEFAULT: [
					0.02666499838232994,
					-0.002201072173193097,
					-0.0020088800229132175,
					0.9996399879455566,
				],
				PRESSED: [
					0.7065635323524475,
					-0.026535363867878914,
					0.025379683822393417,
					0.7066963315010071,
				],
			},
			Middle_C: {
				DEFAULT: [
					0.05026458203792572,
					0.014926768839359283,
					0.005633297376334667,
					0.9986085295677185,
				],
				PRESSED: [
					0.3543305993080139,
					0.0015173490392044187,
					0.0007592000183649361,
					0.9351186752319336,
				],
			},
			Ring_Metacarpal: {
				DEFAULT: [
					0.06746342033147812,
					-0.06527361273765564,
					-0.08486948907375336,
					0.9919604063034058,
				],
				PRESSED: [
					0.0499567873775959,
					-0.028095509856939316,
					-0.07377137988805771,
					0.9956268668174744,
				],
			},
			Ring_A: {
				DEFAULT: [
					0.09256289154291153,
					-0.05345386639237404,
					0.02303459495306015,
					0.9940041303634644,
				],
				PRESSED: [
					0.6746411323547363,
					-0.08898941427469254,
					0.12872140109539032,
					0.7213674783706665,
				],
			},
			Ring_B: {
				DEFAULT: [
					0.039345502853393555,
					0.0189265888184309,
					0.02411668561398983,
					0.9987553358078003,
				],
				PRESSED: [
					0.6844947338104248,
					0.001796810538507998,
					0.00014019243826624006,
					0.729015588760376,
				],
			},
			Ring_C: {
				DEFAULT: [
					0.048003990203142166,
					-0.02104446478188038,
					0.006694173905998468,
					0.9986030459403992,
				],
				PRESSED: [
					0.3726029098033905,
					-0.01477863173931837,
					-0.006282508838921785,
					0.9278520345687866,
				],
			},
			Pinky_Metacarpal: {
				DEFAULT: [
					0.0485701858997345,
					-0.12754254043102264,
					-0.16250784695148468,
					0.9772231578826904,
				],
				PRESSED: [
					0.08449055254459381,
					-0.019927453249692917,
					-0.1490723043680191,
					0.9850084781646729,
				],
			},
			Pinky_A: {
				DEFAULT: [
					0.12926524877548218,
					-0.059700626879930496,
					0.0252252034842968,
					0.9894897937774658,
				],
				PRESSED: [
					0.6234567761421204,
					-0.1030302420258522,
					0.21556174755096436,
					0.7444592714309692,
				],
			},
			Pinky_B: {
				DEFAULT: [
					0.04410816729068756,
					-0.004322762135416269,
					0.008885900489985943,
					0.9989778995513916,
				],
				PRESSED: [
					0.6541510224342346,
					0.0043092346750199795,
					0.0000643649764242582,
					0.7563517093658447,
				],
			},
			Pinky_C: {
				DEFAULT: [
					0.03062133677303791,
					-0.01882816292345524,
					0.02199633978307247,
					0.9991117119789124,
				],
				PRESSED: [
					0.410241961479187,
					-0.006608603987842798,
					-0.00215063220821321,
					0.9119502305984497,
				],
			},
		},
	},
	SEEDBOX: {
		THUMB: {
			Thumb_Metacarpal: {
				DEFAULT: [
					-0.05847484618425369,
					0.4832102060317993,
					0.4646984338760376,
					0.7396919131278992,
				],
				PRESSED: [
					-0.04109467566013336,
					0.48255786299705505,
					0.4503540098667145,
					0.7500869631767273,
				],
			},
			Thumb_A: {
				DEFAULT: [
					0.08022167533636093,
					0.10566344857215881,
					-0.0627758800983429,
					0.9891708493232727,
				],
				PRESSED: [
					0.0802217423915863,
					0.10566341876983643,
					-0.06277590245008469,
					0.9891708493232727,
				],
			},
			Thumb_B: {
				DEFAULT: [
					0.13294348120689392,
					-0.01704186573624611,
					-0.026969842612743378,
					0.9906100630760193,
				],
				PRESSED: [
					0.1329435110092163,
					-0.01704186573624611,
					-0.02696983888745308,
					0.9906100630760193,
				],
			},
			Thumb_C: {
				DEFAULT: [
					0.10615313053131104,
					-0.0021268364507704973,
					-0.01828712970018387,
					0.994179368019104,
				],
				PRESSED: [
					0.10615313798189163,
					-0.0021268411073833704,
					-0.01828712970018387,
					0.994179368019104,
				],
			},
		},
		INDEX: {
			Index_Metacarpal: {
				DEFAULT: [
					0.131587415933609,
					-0.14877039194107056,
					0.1774863600730896,
					0.9638727903366089,
				],
				PRESSED: [
					0.131587415933609,
					-0.14877039194107056,
					0.1774863600730896,
					0.9638727903366089,
				],
			},
			Index_A: {
				DEFAULT: [
					-0.0074324458837509155,
					-0.024955041706562042,
					-0.018546340987086296,
					0.999488890171051,
				],
				PRESSED: [
					-0.0074324458837509155,
					-0.024955041706562042,
					-0.018546340987086296,
					0.999488890171051,
				],
			},
			Index_B: {
				DEFAULT: [
					0.0012645820388570428,
					0.027797739952802658,
					-0.020773593336343765,
					0.9993969202041626,
				],
				PRESSED: [
					0.0012645820388570428,
					0.027797739952802658,
					-0.020773593336343765,
					0.9993969202041626,
				],
			},
			Index_C: {
				DEFAULT: [
					0.04639970511198044,
					0.038880664855241776,
					-0.043582431972026825,
					0.9972141981124878,
				],
				PRESSED: [
					0.04639970511198044,
					0.038880664855241776,
					-0.043582431972026825,
					0.9972141981124878,
				],
			},
		},
		HAND: {
			Middle_Metacarpal: {
				DEFAULT: [
					0.12761390209197998,
					-0.11938062310218811,
					0.053098246455192566,
					0.9831803441047668,
				],
				PRESSED: [
					0.12761390209197998,
					-0.11938062310218811,
					0.053098246455192566,
					0.9831803441047668,
				],
			},
			Middle_A: {
				DEFAULT: [
					0.11428249627351761,
					-0.04873349890112877,
					-0.01421421580016613,
					0.9921504855155945,
				],
				PRESSED: [
					0.11428249627351761,
					-0.04873349890112877,
					-0.01421421580016613,
					0.9921504855155945,
				],
			},
			Middle_B: {
				DEFAULT: [
					0.22899940609931946,
					-0.06695863604545593,
					0.035896360874176025,
					0.9704572558403015,
				],
				PRESSED: [
					0.22899940609931946,
					-0.06695863604545593,
					0.035896360874176025,
					0.9704572558403015,
				],
			},
			Middle_C: {
				DEFAULT: [
					0.12975718080997467,
					0.011109708808362484,
					-0.021635843440890312,
					0.9912474751472473,
				],
				PRESSED: [
					0.12975718080997467,
					0.011109708808362484,
					-0.021635843440890312,
					0.9912474751472473,
				],
			},
			Ring_Metacarpal: {
				DEFAULT: [
					0.14288757741451263,
					-0.14448752999305725,
					-0.09469906985759735,
					0.9745453596115112,
				],
				PRESSED: [
					0.14288757741451263,
					-0.14448752999305725,
					-0.09469906985759735,
					0.9745453596115112,
				],
			},
			Ring_A: {
				DEFAULT: [
					0.3419596552848816,
					-0.08570445328950882,
					0.02940647304058075,
					0.9353361129760742,
				],
				PRESSED: [
					0.3419596552848816,
					-0.08570445328950882,
					0.02940647304058075,
					0.9353361129760742,
				],
			},
			Ring_B: {
				DEFAULT: [
					0.18397696316242218,
					-0.003092183731496334,
					-0.023332420736551285,
					0.9826487302780151,
				],
				PRESSED: [
					0.18397696316242218,
					-0.003092183731496334,
					-0.023332420736551285,
					0.9826487302780151,
				],
			},
			Ring_C: {
				DEFAULT: [
					0.02180776372551918,
					-0.02138412557542324,
					-0.004115563817322254,
					0.9995250105857849,
				],
				PRESSED: [
					0.02180776372551918,
					-0.02138412557542324,
					-0.004115563817322254,
					0.9995250105857849,
				],
			},
			Pinky_Metacarpal: {
				DEFAULT: [
					0.1370553821325302,
					-0.15745265781879425,
					-0.17139390110969543,
					0.9628336429595947,
				],
				PRESSED: [
					0.1370553821325302,
					-0.15745265781879425,
					-0.17139390110969543,
					0.9628336429595947,
				],
			},
			Pinky_A: {
				DEFAULT: [
					0.5018272995948792,
					-0.0973193421959877,
					0.030487099662423134,
					0.858934760093689,
				],
				PRESSED: [
					0.5018272995948792,
					-0.0973193421959877,
					0.030487099662423134,
					0.858934760093689,
				],
			},
			Pinky_B: {
				DEFAULT: [
					0.020729990676045418,
					0.0007990451995283365,
					-0.014842236414551735,
					0.9996746182441711,
				],
				PRESSED: [
					0.020729990676045418,
					0.0007990451995283365,
					-0.014842236414551735,
					0.9996746182441711,
				],
			},
			Pinky_C: {
				DEFAULT: [
					0.06928292661905289,
					-0.006930983625352383,
					-0.014923976734280586,
					0.9974613785743713,
				],
				PRESSED: [
					0.06928292661905289,
					-0.006930983625352383,
					-0.014923976734280586,
					0.9974613785743713,
				],
			},
		},
	},
};
